import ascending from "./ascending.js";
import group, { rollup } from "./group.js";
import sort from "./sort.js";
export default function groupSort(values, reduce, key) {
    return (reduce.length !== 2
        ? sort(rollup(values, reduce, key), (function (_a, _b) {
            var ak = _a[0], av = _a[1];
            var bk = _b[0], bv = _b[1];
            return ascending(av, bv) || ascending(ak, bk);
        }))
        : sort(group(values, key), (function (_a, _b) {
            var ak = _a[0], av = _a[1];
            var bk = _b[0], bv = _b[1];
            return reduce(av, bv) || ascending(ak, bk);
        })))
        .map(function (_a) {
        var key = _a[0];
        return key;
    });
}
